import { useHubStore } from '@/stores/HubStore'
import { sortAscByOrder } from '@/util/sortOrder'

import HubOverview from '../molecules/HubOverview'

function Hubs() {
  const hubs = useHubStore(store => store.hubs)

  return (
    hubs
      .sort(sortAscByOrder)
      .map(hub => (
        <HubOverview
          key={hub.id}
          hub={hub}
        />
      ))
  )
}

export default Hubs
